import { createFeatureSelector, createSelector } from "@ngrx/store";
import { snowflakeStateFeatureKey } from "./reducer";
import { SnowflakeState } from "./state";

export const selectSnowflakeState = createFeatureSelector<SnowflakeState>(
    snowflakeStateFeatureKey,
);

export const selectStatistcsData = createSelector(
    selectSnowflakeState,
    (state) => state.statisticsData,
);
